import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';

const BtnSkeleton: FC<{ className?: string }> = ({ className }) => (
  <Skeleton width="3rem" height="3rem" className={className} />
);

interface LoadingSkeletonProps {
  hasContent: boolean;
  hasPlayButton: boolean;
}

export const LoadingSkeleton: FC<{ id: string } & LoadingSkeletonProps> = ({ hasPlayButton, hasContent, id }) => (
  <div id={id} className="bg-lvl2 card">
    <div className="card-header pb-0">
      <p className="card-title fw-semibold mb-1">
        <Skeleton width="8rem" />
      </p>
      <h2 className="text-white fw-semibold">
        <Skeleton count={2} />
      </h2>
      <p className="text-end">
        <Skeleton width="10rem" />
      </p>
    </div>
    <div className="card-body">{hasContent && <Skeleton count={6} />}</div>
    <div className="card-footer">
      <div className="d-flex flex-row">
        <div className="flex-grow-1">{hasPlayButton && <BtnSkeleton />}</div>
        <BtnSkeleton className="me-1" />
        <BtnSkeleton />
      </div>
    </div>
  </div>
);
